<mat-card class="m-auto padding12 home-card boxshadowgrey">
    <div>
        <button mat-icon-button color="primary" class="back-button" routerLink="/menu">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>

    <div class="content">
    <mat-card-title-group class="home-card" id="title">
        <mat-card-title>{{"COMISSION.HEADER" | translate}}</mat-card-title> 
    </mat-card-title-group>

    <mat-card-content>
        <div class="home-card" id="content">
            <ng-container *ngIf="!allLoaded">
                <mat-progress-spinner mode="indeterminate" color="primary" diameter="50"></mat-progress-spinner>
            </ng-container>
            <ng-container *ngIf="allLoaded">
            <mat-stepper [linear]="true" #stepper>
                <!-- PARAMETER -->
                <mat-step label="{{'COMISSION.PARA' | translate}}" [editable]="false">
                    <!-- PARAMETER -->
                    <div class="parameter">
                        <div class="info">
                            <mat-icon>info_outline</mat-icon>
                            <a id="text">{{"COMISSION.PARA_EXP" | translate}}</a>
                        </div>
                        <button mat-raised-button class="action-btn" (click)="setParaOptions('para')" [disabled]="setStates.para.loading || setStates.para.start">{{"COMISSION.PARA_BTN" | translate}}</button>
                        <ng-container *ngIf="setStates.para.loading">
                            <div class="loading confirm-mess">
                                <mat-progress-spinner mode="indeterminate" color="primary" diameter="30"></mat-progress-spinner>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="setStates.para.progressStart">
                            <div class="progressbar">
                                <mat-progress-bar [mode]="setStates.para.progressMode" [value]="setStates.para.progressValue"></mat-progress-bar>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="setStates.para.progressError.length > 0">
                            <div class="error-mess">
                                <mat-icon color="warn">clear</mat-icon>
                                <a>{{setStates.para.progressError}}</a>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="setStates.para.set">
                            <div class="confirm-mess">
                                <mat-icon color="primary">done</mat-icon>
                                <a>{{"COMISSION.PARA_CONF" | translate}}</a>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="setStates.para.startError">
                            <div class="error-mess">
                                <mat-icon color="warn">clear</mat-icon>
                                <a>{{"COMISSION.ERROR.PARA_ERROR" | translate}}</a>
                            </div>
                        </ng-container>
                    </div>

                    <!-- OPTION -->
                    <div class="options" [class.background]="!setStates.para.set">
                        <div class="info">
                            <mat-icon>info_outline</mat-icon>
                            <a id="text">{{"COMISSION.OPTION_EXP" | translate}}</a>
                        </div>
                        <button mat-raised-button class="action-btn" (click)="setParaOptions('options')" [disabled]="setStates.options.loading || setStates.options.start || !setStates.para.set">{{"COMISSION.OPTION_BTN" | translate}}</button>
                        <ng-container *ngIf="setStates.options.loading">
                            <div class="loading confirm-mess">
                                <mat-progress-spinner mode="indeterminate" color="primary" diameter="30"></mat-progress-spinner>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="setStates.options.progressStart">
                            <div class="progressbar">
                                <mat-progress-bar [mode]="setStates.options.progressMode" [value]="setStates.options.progressValue"></mat-progress-bar>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="setStates.options.progressError.length > 0">
                            <div class="error-mess">
                                <mat-icon color="warn">clear</mat-icon>
                                <a>{{setStates.options.progressError}}</a>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="setStates.options.set">
                            <div class="confirm-mess">
                                <mat-icon color="primary">done</mat-icon>
                                <a>{{"COMISSION.OPTION_CONF" | translate}}</a>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="setStates.options.startError">
                            <div class="error-mess">
                                <mat-icon color="warn">clear</mat-icon>
                                <a>{{"COMISSION.ERROR.OPTION_ERROR" | translate}}</a>
                            </div>
                        </ng-container>
                    </div>
                    

                    <div class="nav-btn-first">
                        <button mat-button matStepperNext class="nav-btn-reverse" (click)="skipEol(stepper)"><!-- [disabled]="!setStates.para.set">-->
                            {{"COMISSION.EOL.NAV_BTN_FORW" | translate}}
                            <mat-icon>arrow_forward_ios</mat-icon>
                        </button>
                    </div>
                </mat-step>

                <ng-template matStepperIcon="disabled"><mat-icon>block</mat-icon></ng-template>

                <!-- EOL -->                 
                <mat-step label="{{'COMISSION.EOL_HEADER' | translate}}" [editable]="false" [state]="eolState" [optional]="eolState === 'disabled'" [completed]="eolCompleted">
                    <div class="eol-container">
                        <div class="head">
                            <!--<mat-radio-group class="radio-btn-group margin-10" [(ngModel)]="modi" [disabled]="eolStarted">
                                <mat-radio-button [value]="'all'" disabled>{{"COMISSION.EOL.ALL_TEST" | translate}}</mat-radio-button>
                                <mat-radio-button [value]="'single'">{{"COMISSION.EOL.SINGLE_TEST" | translate}}</mat-radio-button>
                            </mat-radio-group>-->
                            <div class="btn">
                                <button mat-raised-button class="start-btn margin-10" (click)="startEOL()" [disabled]="!modi || eolStarted">
                                    <div class="btn-content">
                                        <mat-progress-spinner
                                            *ngIf="eolTreeLoading"
                                            diameter="35"
                                            mode="indeterminate"
                                            color="primary"
                                            class="spinner-centered"
                                        ></mat-progress-spinner>
                                        <span class="btn-text" [class.invisible]="eolTreeLoading">
                                            {{"COMISSION.EOL.BTN_START" | translate}}
                                        </span>
                                    </div>
                                </button>
                                <button mat-raised-button class="end-btn margin-10" (click)="endEOL()" [disabled]="!modi || !eolStarted || eolDone">{{"COMISSION.EOL.BTN_END" | translate}}</button>
                            </div>
                            <div class="version-img-container" *ngIf="this.machinenumber != ''">
                                <div class="version-infoset">
                                    <p class="header-version">{{"MENU.NUMBER" | translate}} {{this.machinenumber}}</p>
                                    <div class="version">
                                        <a id="header">{{"MENU.VERSION" | translate}}</a>
                                        <ng-container *ngIf="loading">
                                            <div class="loading">
                                                <mat-progress-spinner mode="indeterminate" color="primary" diameter="35"></mat-progress-spinner>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="this.versions.length > 0">
                                            <ng-container *ngIf="this.version_timestamp != ''">
                                                <a id="timestamp">({{this.version_timestamp | date:"dd/MM/yyyy HH:mm:ss"}})</a>
                                            </ng-container>
                                            <div class="version-info">
                                                <a class="datapoint" id="ecu" *ngFor="let version of versions">
                                                    <a class="datapoint" id="name">{{version.name}}:</a>
                                                    <a class="datapoint" id="value">{{version.version}}</a>
                                                </a>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="home-image" id="container">
                                    <img class="home-image" src="../../assets/images/machine/renderings/{{this.machinenumber.split('.')[0]}}.png" height="150" width="100" alt="Sennebogen Machine" (error)="updateUrl($event)"/>
                                </div>
                            </div>
                        </div>
                        <ng-container *ngIf="eolTreeError">
                            <div class="tree-error">
                                <div class="tree-error-text">{{"COMISSION.EOL.ERROR_TREE" | translate}}</div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="eolStarted">
                            <div class="overview">
                                <div class="tree">
                                    <div class="box">
                                        <div class="box-inline">
                                            <mat-list *ngFor="let item of items">
                                                <!-- parent item-->
                                                <mat-list-item [ngClass]="{'selectedParent': selectedParent === item,'done': item.done}" >
                                                    <div class="item-content">
                                                        <mat-icon [ngClass]="{ 'subitem-done': item.done }">{{ item.done ? 'done' : 'remove' }}</mat-icon>
                                                        <span>{{ item.name }}</span>  
                                                    </div>
                                                </mat-list-item>
                                                <!-- sublists-->
                                                <mat-list-item *ngFor="let sub of item.subItems" [ngClass]="{'selected': selectedItem === sub,'done': sub.state === 'success'}" (click)="clickPermission && onItemClick(sub, item)" [disabled]="!clickPermission">
                                                    <div class="item-content sub-item">
                                                        <mat-icon *ngIf="sub.state === 'success'" class="subitem-done">done</mat-icon>
                                                        <mat-icon *ngIf="sub.state === 'failed'" class="subitem-fail">close</mat-icon>
                                                        <mat-icon *ngIf="sub.state === 'notStarted' || sub.state === 'running'">chevron_right</mat-icon>
                                                        <span>{{ sub.name }}</span>   
                                                    </div>
                                                </mat-list-item>
                                            </mat-list>
                                        </div> 
                                    </div>
                                </div>
                                <div class="test" *ngIf="selectedItem != null">
                                    <h2>{{selectedParent?.name}}</h2>
                                    <h3>{{selectedItem.name}}</h3>

                                    <ng-container *ngIf="successfulTestRetry">
                                        <div class="success-action">
                                            <a class="header-1 margin-bottom-20">{{"COMISSION.EOL.TEST_SUCCESS" | translate}}</a>
                                            <button mat-stroked-button class="confirm-btn" (click)="restartSuccessfulTest()">
                                                <div class="btn-content">
                                                    <span class="btn-text">{{"COMISSION.EOL.RESTART_TEST_BTN" | translate}}</span>
                                                </div>
                                            </button>
                                        </div>
                                    </ng-container>

                                    <!-- TEXT TESTCASE-->
                                    <ng-container *ngIf="selectedItem.type === 'text' && !successfulTestRetry">
                                        <!-- PRECONDITION -->
                                        <div class="precondition">
                                            <a class="header-1">{{"COMISSION.EOL.PREC" | translate}}</a>
                                            <mat-progress-spinner *ngIf="checkRunningTest || checkSettingTest" diameter="20" mode="indeterminate" color="primary"></mat-progress-spinner>
                                            <ng-container *ngIf="testRunning">
                                                <ng-container *ngIf="selectedItem.pre?.length == 0">
                                                    <p>-</p>
                                                </ng-container>
                                                <div class="test-text-block" autoScroll>
                                                <ng-container *ngFor="let pre of selectedItem.pre; let isLast = last">
                                                    <div class="test-text">
                                                        <p style="margin: 0 0 5px" [class.last]="isLast && selectedItem.lastText === 'pre'">{{ pre }}</p>
                                                    </div>
                                                </ng-container>
                                                </div>
                                                <ng-container *ngIf="showConfirmBtn">
                                                    <div class="conf-action">
                                                        <button mat-stroked-button class="confirm-btn" [disabled]="selectedItem.state === 'success' || failedTest || !testRunning || rejectBtnLoading" (click)="confirmTest()">
                                                            <div class="btn-content">
                                                                <mat-progress-spinner *ngIf="confirmBtnLoading" diameter="20" mode="indeterminate" color="accent" class="spinner-centered"></mat-progress-spinner>
                                                                <span class="btn-text" [class.invisible]="confirmBtnLoading">{{"COMISSION.EOL.CONF_BTN" | translate}}</span>
                                                            </div>
                                                        </button>
                                                        <button mat-stroked-button class="reject-btn" [disabled]="selectedItem.state === 'success' || failedTest || !testRunning || confirmBtnLoading" (click)="rejectTest()">
                                                            <div class="btn-content">
                                                                <mat-progress-spinner *ngIf="rejectBtnLoading" diameter="20" mode="indeterminate" color="accent" class="spinner-centered"></mat-progress-spinner>
                                                                <span class="btn-text" [class.invisible]="rejectBtnLoading">{{"COMISSION.EOL.REJECT_BTN" | translate}}</span>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </ng-container>
                                            </ng-container>
                                        </div>

                                        <!-- EXECUTION -->
                                        <div class="execution">
                                            <a class="header-1">{{"COMISSION.EOL.EXEC" | translate}}</a>
                                            <ng-container *ngIf="preFulfilled">
                                                <ng-container *ngIf="selectedItem.exec?.length == 0">
                                                    <p>-</p>
                                                </ng-container>
                                                <div class="test-text-block" autoScroll>
                                                <ng-container *ngFor="let exec of selectedItem.exec; let isLast = last">
                                                    <div class="test-text">
                                                        <p style="margin: 0 0 5px" [class.last]="isLast && selectedItem.lastText === 'exec'">{{ exec }}</p>
                                                    </div>
                                                </ng-container>
                                                </div>
                                            </ng-container>
                                        </div>

                                        <!-- EVALUATION -->
                                        <div class="evaluation">
                                            <a class="header-1">{{"COMISSION.EOL.EVAL" | translate}}</a>
                                            <ng-container *ngIf="execFulfilled">
                                                <ng-container *ngIf="selectedItem.eval?.length == 0">
                                                    <p>-</p>
                                                </ng-container>
                                                <div class="test-text-block" autoScroll>
                                                <ng-container *ngFor="let eval of selectedItem.eval; let isLast = last">
                                                    <div class="test-text">
                                                        <p style="margin: 0 0 5px" [class.last]="isLast && selectedItem.lastText === 'eval'">{{eval}}</p>
                                                        <mat-progress-spinner *ngIf="loadEval" diameter="20" mode="indeterminate" color="primary" class="test-spinner"></mat-progress-spinner>
                                                    </div>
                                                </ng-container>
                                                </div>
                                            </ng-container>
                                        </div>
                                        <ng-container *ngIf="failedTest">
                                            <div class="conf-action">
                                                <button mat-stroked-button class="confirm-btn" (click)="restartTest()">
                                                    <div class="btn-content">
                                                        <span class="btn-text">{{"COMISSION.EOL.RESTART_TEST_BTN" | translate}}</span>
                                                    </div>
                                                </button>
                                            </div>
                                        </ng-container>
                                    </ng-container>

                                    <!-- FOTO TESTCASE-->
                                    <ng-container *ngIf="selectedItem.type === 'foto' && !successfulTestRetry">
                                        <div class="foto-container">
                                            <!-- IMAGE - LEFT-->
                                            <div class="foto-image-container">
                                                <img class="foto-image" [src]="selectedImgUrl" alt="Foto" (click)="openImage()"/>
                                                <div class="img-overlay" *ngIf="imgOpen" (click)="closeImage()">
                                                    <button class="close-btn"><mat-icon>close</mat-icon></button>
                                                    <img [src]="selectedImgUrl" alt="Foto" class="full-image"/>
                                                </div>
                                            </div>
                                            <!-- PRECONDITION - RIGHT-->
                                            <div class="foto-list-container">
                                                <mat-progress-spinner *ngIf="checkRunningTest || checkSettingTest" diameter="20" mode="indeterminate" color="primary"></mat-progress-spinner>
                                                <ng-container *ngIf="testRunning">
                                                    <ng-container *ngIf="selectedItem.pre?.length == 0">
                                                        <p>-</p>
                                                    </ng-container>
                                                    <div class="test-text-block" autoScroll>
                                                    <ng-container *ngFor="let pre of selectedItem.pre; let isLast = last">
                                                        <div class="test-text">
                                                            <p style="margin: 0 0 5px" [class.last]="isLast && selectedItem.lastText === 'pre'">{{ pre }}</p>
                                                        </div>
                                                    </ng-container>
                                                    </div>
                                                    <ng-container *ngIf="showConfirmBtn">
                                                        <div class="conf-action">
                                                            <button mat-stroked-button class="confirm-btn" [disabled]="selectedItem.state === 'success' || failedTest || !testRunning || rejectBtnLoading" (click)="confirmTest()">
                                                                <div class="btn-content">
                                                                    <mat-progress-spinner *ngIf="confirmBtnLoading" diameter="20" mode="indeterminate" color="accent" class="spinner-centered"></mat-progress-spinner>
                                                                    <span class="btn-text" [class.invisible]="confirmBtnLoading">{{"COMISSION.EOL.CONF_BTN" | translate}}</span>
                                                                </div>
                                                            </button>
                                                            <button mat-stroked-button class="reject-btn" [disabled]="selectedItem.state === 'success' || failedTest || !testRunning || confirmBtnLoading" (click)="rejectTest()">
                                                                <div class="btn-content">
                                                                    <mat-progress-spinner *ngIf="rejectBtnLoading" diameter="20" mode="indeterminate" color="accent" class="spinner-centered"></mat-progress-spinner>
                                                                    <span class="btn-text" [class.invisible]="rejectBtnLoading">{{"COMISSION.EOL.REJECT_BTN" | translate}}</span>
                                                                </div>
                                                            </button>
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </div>
                                        </div>
                                        <!-- EXECUTION -->
                                        <div class="execution">
                                            <a class="header-1">{{"COMISSION.EOL.EXEC" | translate}}</a>
                                            <ng-container *ngIf="preFulfilled">
                                                <ng-container *ngIf="selectedItem.exec?.length == 0">
                                                    <p>-</p>
                                                </ng-container>
                                                <div class="test-text-block" autoScroll>
                                                <ng-container *ngFor="let exec of selectedItem.exec; let isLast = last">
                                                    <div class="test-text">
                                                        <p style="margin: 0 0 5px" [class.last]="isLast && selectedItem.lastText === 'exec'">{{ exec }}</p>
                                                    </div>
                                                </ng-container>
                                                </div>
                                            </ng-container>
                                        </div>

                                        <!-- EVALUATION -->
                                        <div class="evaluation">
                                            <a class="header-1">{{"COMISSION.EOL.EVAL" | translate}}</a>
                                            <ng-container *ngIf="execFulfilled">
                                                <ng-container *ngIf="selectedItem.eval?.length == 0">
                                                    <p>-</p>
                                                </ng-container>
                                                <div class="test-text-block" autoScroll>
                                                <ng-container *ngFor="let eval of selectedItem.eval; let isLast = last">
                                                    <div class="test-text">
                                                        <p style="margin: 0 0 5px" [class.last]="isLast && selectedItem.lastText === 'eval'">{{eval}}</p>
                                                        <mat-progress-spinner *ngIf="loadEval" diameter="20" mode="indeterminate" color="primary" class="test-spinner"></mat-progress-spinner>
                                                    </div>
                                                </ng-container>
                                                </div>
                                            </ng-container>
                                        </div>
                                        <ng-container *ngIf="failedTest">
                                            <div class="conf-action">
                                                <button mat-stroked-button class="confirm-btn" (click)="restartTest()">
                                                    <div class="btn-content">
                                                        <span class="btn-text">{{"COMISSION.EOL.RESTART_TEST_BTN" | translate}}</span>
                                                    </div>
                                                </button>
                                            </div>
                                        </ng-container>
                                    </ng-container>

                                    <!-- ACTION BTN GROUP -->
                                    <div class="action-btn-group" *ngIf="selectedParent && selectedItem && selectedParent.subItems?.length">
                                        <div class="nav-btn-group">
                                            <button mat-button class="nav-btn" [disabled]="confirmBtnLoading || rejectBtnLoading || !clickPermission" (click)="clickPermission && goPrevious()" *ngIf="hasPrevious()">
                                                <mat-icon>arrow_back_ios</mat-icon>
                                                {{"COMISSION.EOL.NAV_BTN_BACK" | translate}}
                                            </button>
                                        </div>
                                        <div class="nav-btn-group">
                                            <button mat-button class="nav-btn-reverse" [disabled]="confirmBtnLoading || rejectBtnLoading || !clickPermission" (click)="clickPermission && goNext()" *ngIf="hasNext()">
                                                {{"COMISSION.EOL.NAV_BTN_FORW" | translate}}
                                                <mat-icon>arrow_forward_ios</mat-icon>
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="progress">
                                <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
                                <a class="percent">{{progress}}%</a>
                            </div>
                            <div class="save-btn-container" *ngIf="progress === 100">
                                <div class="end-message">
                                    <mat-icon>done</mat-icon>
                                    <a>{{"COMISSION.EOL.END_TEST_MES" | translate}}</a>
                                </div>
                                <!--<button mat-raised-button class="save-btn" (click)="saveEOL()">{{"COMISSION.EOL.END_TEST_BTN" | translate}}</button>-->
                            </div>   
                        </ng-container>
                    </div>

                    <div class="nav-btn-first">
                        <button mat-button class="nav-btn-reverse" (click)="continueOn(stepper)">
                            {{"COMISSION.EOL.NAV_BTN_FORW" | translate}}
                            <mat-icon>arrow_forward_ios</mat-icon>
                        </button>
                    </div>
                    <!--<div class="nav-btn-first">
                        <button mat-button class="nav-btn-reverse" [disabled]="!this.roleService.isRole('Expert') && !eolDone" (click)="goToLogStep(stepper)">
                            {{eolDone ? ("COMISSION.EOL.NAV_BTN_FORW_SAVE" | translate) : ("COMISSION.EOL.NAV_BTN_FORW" | translate)}}
                            <mat-icon>arrow_forward_ios</mat-icon>
                        </button>
                    </div>-->
                </mat-step>

                <mat-step label="{{'COMISSION.REPORT' | translate}}" [editable]="false" [state]="eolState" [optional]="eolState === 'disabled'">
                    <div class="report">
                        <div class="info">
                            <mat-icon>info_outline</mat-icon>
                            <a id="text">{{"COMISSION.REPORT_EXP" | translate}}</a>
                        </div>
                        <ng-container *ngIf="reportLoading">
                            <div class="report-loading">
                                <div class="loading confirm-mess">
                                    <mat-progress-spinner mode="indeterminate" color="primary" diameter="30"></mat-progress-spinner>
                                </div>
                                <a class="report-text">{{"COMISSION.REPORT_TEXT" | translate}}</a>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="reportSuccess">
                            <div class="report-success">
                                <div class="confirm-mess">
                                    <mat-icon color="primary">done</mat-icon>
                                    <a>{{"COMISSION.REPORT_SUCCESS" | translate }}</a>
                                </div>
                                <a class="report-link" [href]="reportLink" target="_blank">{{"COMISSION.REPORT_LINK" | translate}}</a>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="reportError">
                            <div class="error-mess">
                                <mat-icon color="warn">clear</mat-icon>
                                <a>{{"COMISSION.REPORT_ERROR" | translate}}</a>
                            </div>
                        </ng-container>

                    </div>
                    <div class="nav-btn-first">
                        <button mat-button matStepperNext class="nav-btn-reverse" (click)="initLogPage()">
                            {{"COMISSION.EOL.NAV_BTN_FORW" | translate}}
                            <mat-icon>arrow_forward_ios</mat-icon>
                        </button>
                    </div>
                </mat-step>

                <!-- LOGGING -->
                <mat-step label="{{'COMISSION.LOG' | translate}}" [editable]="false" [completed]="lastStepCompleted" [state]="state">
                    <div class="logging">
                        <div class="info">
                            <mat-icon>info_outline</mat-icon>
                            <a id="text">{{"COMISSION.LOG_EXP" | translate}}</a>
                        </div>
                        
                        <div class="log-data">
                            <div class="log-info">
                                <a class="bold">{{"COMISSION.USER" | translate}}</a>
                                <a>{{user}}</a>
                            </div>
                            
                            <div class="version-container">
                                <div class="log-info">
                                    <a class="bold">{{"MENU.NUMBER" | translate}}</a>
                                    <a>{{this.machinenumber}}</a>
                                </div>
                                <div class="version">
                                    <a id="header">{{"MENU.VERSION" | translate}}</a>
                                    <ng-container *ngIf="loading">
                                        <div class="loading">
                                            <mat-progress-spinner mode="indeterminate" color="primary" diameter="35"></mat-progress-spinner>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="this.versions.length > 0">
                                        <ng-container *ngIf="this.version_timestamp != ''">
                                            <a id="timestamp">({{this.version_timestamp | date:"dd/MM/yyyy HH:mm:ss"}})</a>
                                        </ng-container>
                                        <div class="version-info">
                                            <a class="datapoint" id="ecu" *ngFor="let version of versions">
                                                <a class="datapoint" id="name">{{version.name}}:</a>
                                                <a class="datapoint" id="value">{{version.version}}</a>
                                            </a>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="hash-container">
                                <div class="hash">
                                    <a class="bold">{{"COMISSION.HASH_PARA" | translate}}</a>
                                    <ng-container *ngIf="paraHashLoading">
                                        <div class="loading-hash">
                                            <mat-progress-spinner mode="indeterminate" color="primary" diameter="20"></mat-progress-spinner>
                                        </div>
                                    </ng-container>
                                    <a>{{strHashPara}}</a>
                                </div>
                                <div class="hash">
                                    <a class="bold">{{"COMISSION.HASH_OPTION" | translate}}</a>
                                    <ng-container *ngIf="optionHashLoading">
                                        <div class="loading-hash">
                                            <mat-progress-spinner mode="indeterminate" color="primary" diameter="20"></mat-progress-spinner>
                                        </div>
                                    </ng-container>
                                    <a>{{strHashOption}}</a>
                                </div>
                            </div>

                            <div class="log-info">
                                <a class="bold">{{"COMISSION.COMMENT" | translate}}:</a>
                                <mat-form-field class="comment">
                                    <textarea matInput placeholder="{{'COMISSION.COMMENT_TIP' | translate}}" [(ngModel)]="comment"></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                        <button mat-raised-button class="action-btn" (click)="logAll()" [disabled]="logDone">{{"COMISSION.LOG_BTN" | translate}}</button>
                        <ng-container *ngIf="loadingLog">
                            <div class="loading confirm-mess">
                                <mat-progress-spinner mode="indeterminate" color="primary" diameter="30"></mat-progress-spinner>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="lastStepCompleted">
                            <div class="confirm-mess">
                                <mat-icon color="primary">done</mat-icon>
                                <a>{{"COMISSION.LOG_CONF" | translate}}</a>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="logError">
                            <div class="confirm-mess">
                                <mat-icon color="warn">clear</mat-icon>
                                <a>{{"COMISSION.LOG_ERROR" | translate}}</a>
                            </div>
                        </ng-container>
                    </div>
                </mat-step>
            </mat-stepper>
            </ng-container>
        </div>
    </mat-card-content>
    </div>
</mat-card>

